/**
 * Cart URL Params
 *
 * Lê o parâmetro ?add=variantId:qty,variantId:qty da URL,
 * adiciona os itens ao carrinho via Ajax e abre o cart drawer.
 *
 * Formato de URL:
 *   https://seusite.com.br/?add=51711217631512:1,51658491101464:2
 *
 * Enquanto esse parâmetro estiver presente, o popup de acesso rápido
 * também não será exibido.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var addParam = params.get('add');

  if (!addParam) return;

  var items = addParam.split(',').reduce(function (acc, part) {
    var segments = part.trim().split(':');
    var id = parseInt(segments[0], 10);
    var quantity = parseInt(segments[1], 10);
    if (!isNaN(id)) {
      acc.push({ id: id, quantity: isNaN(quantity) ? 1 : quantity });
    }
    return acc;
  }, []);

  if (items.length === 0) return;

  function removeAddParam() {
    var url = new URL(window.location.href);
    url.searchParams.delete('add');
    history.replaceState({}, '', url.toString());
  }

  function openCartDrawer() {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    });
  }

  function dispatchCartUpdate() {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: {} },
      })
    );
  }

  function doAddToCart() {
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    var body = { items: items };
    if (sectionIds.length > 0) {
      body.sections = sectionIds.join(',');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('[cart-url-params] Erro ao adicionar ao carrinho:', response.description);
          return;
        }

        removeAddParam();

        if (response.sections && Object.keys(response.sections).length > 0) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { sections: response.sections } },
            })
          );
        } else {
          dispatchCartUpdate();
        }

        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[cart-url-params] Erro inesperado:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doAddToCart);
  } else {
    doAddToCart();
  }
})();
